import Loading from './icon/Loading';
import LoadingMask from './icon/LoadingMask';
import LoadingCircle from './icon/LoadingCircle';
import Checkbox from './btn/Checkbox';
import PlayButton from './btn/PlayButton';
import ConnectButton from './btn/ConnectButton';
import PersonMerz from './comps/PersonMerz';
import FormatHtml from './comps/FormatHtml';

const components = {
    Loading,
    LoadingMask,
    LoadingCircle,
    Checkbox,
    PlayButton,
    ConnectButton,
    PersonMerz,
    FormatHtml
}

const install = function (Vue, Option) {
    Object.keys(components).forEach((key) => {
        Vue.component(components[key].name, components[key])
    })
}
export default {
    install
}


// WEBPACK FOOTER //
// ./src/components/g_plugin/index.js